<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="2"></aboutBannerVue>
        <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">关于我们</p>
            <div class="clearfix content mt36">
                <div :class="isMobile?'':'fl contentLeft'">
                    <p>瑞和安惠项目管理集团有限公司创建于2000年，是集招标采购、造价咨询、工程监理、前期咨询、PPP咨询、项目管理、BIM应用及IPMP项目管理培训于一体的全过程工程咨询企业。</p>
                    <p>瑞和安惠始终秉承“诚信至高处，服务无限时”的服务理念，服务体系不断扩展，至今已发展成为拥有9个全过程咨询公司、11个区域分公司及事业部、多个省外机构以及1个信息技术公司的集团企业，服务网点遍布全省11个地市及雄安、天津、河南、山东、山西、江苏、湖北、海南、四川等地。</p>
                    <p>在“互联网+工程咨询”的浪潮中，瑞和安惠凭借多项行业甲级资质以及成熟的信息化技术，组建了完整的全过程工程咨询业务链，构建了完善的智能化OA办公系统，研发了多个数字化咨询业务平台，在工程咨询行业实现了数字化转型。</p>
                </div>
                <img :class="isMobile?'rencaiImg':'fr rencai'" src="@/assets/aboutUs/intro/rencai.png" alt="">
            </div>
            <div class="content">
                <p>从实践中来，到实践中去。瑞和安惠总结从业二十余年的项目管理精华与实践经验，投入各专业领域精英数十人，经过五年的梳理与提炼，出版发行了“工程咨询理论与实践研究系列丛书”，共计10本著作。</p>
                <p>深耕技术创新，助力行业进步。瑞和安惠项目管理集团依托成熟的全过程工程咨询和BIM应用经验，依据现行国家标准，参与编制了多项国家及河北省工程建设标准。</p>
            </div>
            <p class="font20 fontw mt42">核心优势</p>
            <div class="yousBox" v-for="(item,index) in guocList" :key="index">
                <div class="clearfix">
                    <span class="points fl"></span>
                    <span class="fl">{{item.title}}</span>
                </div>
                <p>{{item.content}}</p>
            </div>
        </div>
        <div :class="isMobile?'organBoxs':'organBox'">
            <div :class="isMobile?'organsM':'organs'">
                <p class="font20 fontw" :class="isMobile?'ml10':''">组织架构</p>
                <div :class="isMobile?'organsShow':'organsBg'">
                    <img src="@/assets/aboutUs/intro/jituan.png" alt="">
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
   
</style>
<script>
    import aboutBannerVue from '@/components/aboutBanner'
    export default {
		name:'CorporateCulture',
        components:{aboutBannerVue},
        data() {
            return {
                guocList:[
                    {
                        title:'全过程综合咨询服务能力',
                        content:'瑞和安惠以工程咨询、造价咨询、招标代理、管理咨询、项目管理培训与推广为起点，着眼于全过程工程咨询与项目管理咨询的综合企业集团，从项目的决策阶段、前期阶段到设计阶段、实施阶段、竣工移交阶段，瑞和安惠的专业服务涵盖了工程项目的全过程。'
                    },
                    {
                        title:'具有项目各阶段深度服务能力',
                        content:'瑞和安惠一直都着重于各阶段服务的创新与提升，各阶段形成了单项业务的服务标准模式，每项服务都有一批优良专才团队，积累了丰富的咨询经验，具备深度咨询服务能力。'
                    },
                    {
                        title:'组织机构完善，驻地机构遍布全省，服务更及时、高效',
                        content:'按照现代企业管理制度和项目管理的主旨，瑞和安惠实施项目化管理，建立了适合工程咨询企业的项目管理运行机制——职能式与矩阵式相结合的复合式组织结构。集团设有财务中心、技术中心、行政人事法务中心、运营中心、信息中心等运营保障部门，同时全省各地市设有直属分公司或办事处，并在多个省份设有独立分支机构。'
                    },
                    {
                        title:'具有丰富的人才资源',
                        content:'瑞和安惠非常重视对人才的吸纳、培养，并努力为专业人才的成长创造条件，目前拥有三百余名专业知识结构合理、实践经验丰富的专职技术人员。其中，中、高级职称以上专业技术人员及各类注册执业人员均超过从业人员总数的60%。在2008年开始进行IPMP认证，截止目前，39人通过IPMP A/B/C级项目经理认证。'
                    },
                    {
                        title:'以项目管理为导向的组织机构和管理体系',
                        content:'瑞和安惠运用现代项目管理的技术、方法、理念以及集团公司现阶段各项业务实际情况，以ISO9000为基础，建立了适用于全过程工程项目管理服务和各阶段服务的项目管理体系，并形成了各项业务的服务标准——项目管理手册（PMHANDBOOK）。在2018年通过了国际项目管理协会（IPMA）面向组织的企业项目管理能力认证（IPMA Delta），并取得IV级（体系化管理级）国际认证。'
                    },
                    {
                        title:'面向项目全过程管理的信息化系统',
                        content:'瑞和安惠项目管理依据自身项目管理实践经验，结合项目管理需要及信息化发展的具体情况，自主研发了公司项目管理信息化系统，从2004年开始，经过不断完善，系统已经涵盖了公司所有项目的项目管理及日常管理。'
                    },
                    {
                        title:'项目管理理论应用与实践经验丰富',
                        content:'瑞和安惠发起组建了河北省项目管理协会，依托协会构建政府、企业交流平台；结合政府投资项目特点，运用现代项目管理，推进政府投资项目管理的普及与深化；创新现代项目管理普及、推广形式，促进现代项目管理的应用。先后为曹妃甸基础设施投资有限公司、华北制药等大型机构咨询、编制项目管理手册，在现代项目管理应用领域发挥积极作用。'
                    },
                    {
                        title:'政府投资项目管理领域优势显著',
                        content:'瑞和安惠依托全过程咨询服务优势在河北省政府投资领域做了一些有益的尝试，探索政府投资项目代建模式。运用现代项目管理，结合政府投资特点，进行政府投资项目培训与管理咨询；积极参与河北省政府投资项目代建制制度制定；参与政府投资项目代建制,先后承接了承德医学院新校区项目、曹妃甸工业区四大联检机构办公楼、承德奥林匹克体育中心（河北第一个政府投资代建制项目）、唐山南湖西北片区安置区工程等重大政府投资项目项目管理、代建工作。'
                    },
                ],

            }
        },
        mounted(){
        },
        methods:{
        }
	}
</script>

<style scoped>
    .content{
        font-size: 16px;
        color: #333333;
        font-weight: 400;
        line-height: 36px;
        text-indent: 2em;
    }
    .contentLeft{
        width: 585px;
    }
    .rencai{
        width: 580px;
        height: 293px;
        margin-top: 18px;
    }
    .rencaiImg{
        display: block;
        max-width: 100%;
        margin: 15px 0;
    }
    .yousBox{
        line-height:36px;
        margin-top: 15px;
    }
    .yousBox p{
        text-indent: 2em;
        margin-left: 2px;
    }
    .points{
        width: 16px;
        height: 16px;
        background: #247CD6;
        margin-left: 10px;
        margin-right: 9px;
        margin-top: 10px;
    }
    .points+span{
        color: #247CD6;
        font-size: 16px;
        font-weight: bold;
    }
    .organBox{
        width: 100%;
        height: 770px;
        background: url('../../assets/aboutUs/intro/introBg.png');
        background-size: 100% 100%;
        margin-top: 42px;
    }
    .organBoxs{
        width: 100%;
        background: url('../../assets/aboutUs/intro/introBg.png');
        background-size: cover;
        margin-top: 20px;
        padding-bottom: 20px;
    }
    .organs{
        width: 1200px;
        margin: 0 auto;
        padding-top: 42px;
    }
    .organsM{
        width: 100%;
        padding-top: 20px;
    }
    .organsBg{
        width: 1200px;
        height: 600px;
        margin: 0 auto;
        margin-top: 42px;
        padding-top: 43px;
        background-color: #fff;
    }
    .organsBg img{
        display: block;
        width: 955px;
        margin: 0 auto;
    }
    .organsShow{
        width: calc(100% - 20px);
        margin: 0 auto;
        margin-top: 20px;
    }
    .organsShow img{
        width: 100%;
    }
</style>